import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { homeIcon } from "../../constants/icons";

const BreadCrumbs = ({ pages }) => {
    return (
        <nav aria-label="breadcrumb" className="myk__learner-breadcrumbs">
            <ul>
                {pages.map((page, index) => (
                    <li key={index} className="breadcrumb-item">
                        <div className="d-flex align-items-center gap-2">
                            {page.url ? (
                                <div className="breadcrumb-item-link d-flex align-items-center gap-2">
                                    {page.icon && <span>{page.icon}</span>}
                                    <Link to={page.url} className="breadcrumb-link">
                                        {page.label}
                                    </Link>
                                </div>
                            ) : (
                                <div className="breadcrumb-item-current d-flex align-items-center gap-2">
                                    {page.icon && <span>{page.icon}</span>}
                                    <span>{page.label}</span>
                                </div>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

BreadCrumbs.propTypes = {
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.node,
            label: PropTypes.string.isRequired,
            url: PropTypes.string
        })
    )
};

BreadCrumbs.defaultProps = {
    pages: [
        { icon: homeIcon, label: "Home", url: "/" }
    ]
};

export default BreadCrumbs;
